<template>
  <!-- <div class="template" > -->
  <div class="v-scroll-content relative-position">
    <div>
      <div :style="getStyle()"></div>
    </div>
    <template v-if="(!selectedAllBet && !bool_leagueToggle && !open_RBMarket && !hotSchedule)">
      <!-- <template v-if="selectedBettype.tmpltId == '1'"> -->
      <template v-if="specialEvent">
          <specialEventCommon></specialEventCommon>
      </template>
      <template v-else-if="checkTemplate('1')">
        <!-- <template v-if="selectedShow != '2'">
          <soccerCommonSL></soccerCommonSL>
        </template>
        <template v-else> -->
          <soccerCommon></soccerCommon>
        <!-- </template> -->
      </template>
      <!-- <template v-else-if="selectedBettype.tmpltId == '2'"> -->
      <template v-else-if="checkTemplate('2')">
        <soccerCorrectScore></soccerCorrectScore>
      </template>
      <!-- <template v-else-if="selectedBettype.tmpltId == '3'"> -->
      <template v-else-if="checkTemplate('3')">
        <soccerTotalGoal></soccerTotalGoal>
      </template>
      <!-- <template v-else-if="selectedBettype.tmpltId == '4'"> -->
      <template v-else-if="checkTemplate('4')">
        <soccerHTFT></soccerHTFT>
      </template>
      <!-- <template v-else-if="selectedBettype.tmpltId == '6' || selectedBettype.tmpltId == '11'"> -->
      <template v-else-if="checkTemplate('6') || checkTemplate('11')">
        <sportOutright></sportOutright>
      </template>
      <!-- <template v-else-if="selectedBettype.tmpltId == '7'"> -->
      <template v-else-if="checkTemplate('7')">
        <!-- <otherSportCommon></otherSportCommon> -->
        <otherSportCommon2></otherSportCommon2>
      </template>
      <!-- <template v-else-if="selectedBettype.tmpltId == '8'"> -->
      <template v-else-if="checkTemplate('8')">
        <otherSportCommon2></otherSportCommon2>
      </template>
      <template v-else>
      </template>
    </template>
    <template v-else-if="open_RBMarket">
      <inPlayCommon></inPlayCommon>
    </template>
    <template v-else-if="hotSchedule">
      <hotSportCommon></hotSportCommon>
    </template>

    <!-- add checking for today only early not suitable dis checking -->
    <div v-if="(eventList && eventList.length == 0 && rbeventList && rbeventList.length==0)" :style="hotSchedule ? { position: 'inherit', top: '45px' } : {}">
      <template v-if="!showFavEvents">
        <div class="column yb-flex-center empty fit">
          <div data-v-31145778="" class="wrap empty-wrap" style="margin-bottom: 0px;">
            <div class="img dark" style="width: 180px; height: 180px;"></div>
            <div class="text-center">{{langSport['SPORT_TABLE.NO_DATA']}}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <template
          v-if="showFavEvents && Object.keys(sortedEventList).length == 0 && Object.keys(sortedFavRbEventList).length == 0">
          <!-- <div class="noInfo" v-html="langSport['SPORT_TABLE.MSG_NO_FAV']"></div> -->
          <div class="column yb-flex-center empty fit">
          <div data-v-31145778="" class="wrap empty-wrap" style="margin-bottom: 0px;">
            <div class="img dark" style="width: 180px; height: 180px;"></div>
            <div class="text-center">{{langSport['SPORT_TABLE.NO_DATA']}}</div>
          </div>
        </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'

import EventBus from '../../events/event-bus'
import inPlayCommon from './inPlayCommon'
import soccerCommon from './soccerCommon'
import hotSportCommon from './hotSportCommon'
// import soccerCommonSL from './soccerCommonSL' //single line
import soccerAllCommon from './soccerAllCommon'
import soccerCorrectScore from './soccerCorrectScore'
import soccerTotalGoal from './soccerTotalGoal'
import soccerHTFT from './soccerHTFT'
// import otherSportCommon from './otherSportCommon'
import otherSportCommon2 from './otherSportCommon2'
import sportOutright from './sportOutright'
import specialEventCommon from './specialEventCommon'

export default {
  components: {
    inPlayCommon,
    soccerCommon,
    hotSportCommon,
    // soccerCommonSL,
    soccerAllCommon,
    soccerCorrectScore,
    soccerTotalGoal,
    soccerHTFT,
    // otherSportCommon,
    otherSportCommon2,
    sportOutright,
    specialEventCommon,
  },
  data() {
    return {
      reloading: true,
      langSport: window.lang['sportTableLang'],
    }
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'eventList',
      'rbeventList',
      'selectedBettype',
      'selectedShow',
      'selectedAllBet',
      'selectedMarket',
      // 'matchAllBet',
      'showFavEvents',
      'sortedEventList',
      'sortedFavRbEventList',
      'bool_leagueToggle',
      'open_RBMarket',
      'market',
      'isParlayTab',
      'previousBettype',
      'isGameBannerSelected',
      'hotSchedule',
      'selectedSport',
      'specialEvent',
    ])
  },
  beforeMount() {
    EventBus.$on('templateChange', ((reloading) => {
      this.reloading = reloading
    }).bind(this))
  },
  mounted() {
  },
  destroyed() {
    EventBus.$off('templateChange')
  },
  methods: {
    getStyle(){
      var val = '36'
      if(this.open_RBMarket && !this.showFavEvents){
        val = '84'
      }else if(this.$store.getters.selectedBettype.tmpltId ==11 && !this.showFavEvents){
        val = '84'
      }else if(this.$store.getters.selectedBettype.betTypId ==5 && this.isParlayTab ){ // && !this.showFavEvents
        val = '90'
      }else if(this.selectedMarket==this.market.earlyMarket.key && this.$store.getters.selectedBettype.betTypId != 6){
        val = '90'
      }
      if((this.isGameBannerSelected || this.specialEvent) && this.selectedMarket==this.market.earlyMarket.key){
        val = '36'
      }

      return 'height:' + val + 'px'
    },
    checkTemplate(tmplt){
      var selectedTmplt = this.$store.getters.selectedBettype.tmpltId
      if(this.$store.getters.selectedBettype.betTypId == '5' && !this.isParlayTab){
        selectedTmplt = this.previousBettype && this.previousBettype.bettype? this.previousBettype.bettype.tmpltId:'1'
      } 
      return selectedTmplt == tmplt
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/sportTemplate.vue